export const readText = (data: FormData, name: string): string => {
    const value = data.get(name);
    return typeof value === "string" ? value.trim() : "";
};

export const readEuroCents = (data: FormData, name: string): number | null => {
    const value = readText(data, name);
    if (!/^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(value)) return null;
    const cents = Math.round(Number(value) * 100);
    return cents >= 1 && cents <= 100_000_000 ? cents : null;
};

export const readLoginCredentials = (data: FormData) => {
    const email = readText(data, "email");
    const password = data.get("password");
    if (
        email.length > 254 ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ||
        typeof password !== "string" ||
        !password ||
        password.length > 1024
    ) {
        return null;
    }
    return { email: email.toLowerCase(), password };
};
